import {AgentPreferences, defaultPrefs} from "../util/defaultPrefs.tsx";

export const defaultDispatcherPrefs: AgentPreferences = {
    ...defaultPrefs,
    inspectionTierColors: [
        {tier: "NOTHING", color: "primary", watched: true},
        {tier: "PRELIM", color: "warning", watched: true},
        {tier: "FINAL", color: "neutral", watched: true},
    ],
};

